<template>
    <div class="home">
        <!-- <div class="home" v-loading.fullscreen.lock="$store.state.user.showLoading"> -->
        <nav-menu></nav-menu>
        <div class="home-index">
            <router-view />
        </div>
        <my-footer></my-footer>
    </div>
</template>

<script>
import NavMenu from "@/components/navMenu/NavMenu.vue"
import MyFooter from "@/components/footer/myFooter.vue"
export default {
    name: "home",
    components: {
        MyFooter,
        NavMenu,
    },
    data() {
        return {
            name: "home",
            showLogin: false
        }
    },
    mounted() {
    }
}
</script>

<style lang="less" scoped>
.home {
    .home-index {
        min-height: 725px;
    }
}
</style>